import { useMemo } from "react";
import { GetFeatureFlagsOrganization } from "@Api/featureFlagApi";
import { useAsync } from "@Hooks";
import { useFeatureFlags } from "@Hooks";

export function useFeatureFlagMenuFilter(menu) {
  const globalFeatureFlags = useFeatureFlags();
  const { data: featureFlagsOrganization } = useAsync(GetFeatureFlagsOrganization, "FEATURE_FLAGS");
  return useMemo(() => {
    const orgFlagMap = {};
    if (Array.isArray(featureFlagsOrganization)) {
      featureFlagsOrganization.forEach((f) => {
        if (f.flag?.identifier) {
          orgFlagMap[f.flag.identifier] = f.value;
        }
      });
    }

    return menu.filter((section) => {
      if (!section.featureFlag) return true;

      const globalValue = globalFeatureFlags?.[section.featureFlag];
      if (globalValue === false) return false;

      const orgValue = orgFlagMap[section.featureFlag];
      if (orgValue === false) return false;

      return true;
    });
  }, [menu, globalFeatureFlags, featureFlagsOrganization]);
}
